import Tooltip from '@components/common/Tooltip';
import React from 'react';
import {
  Container,
  TitleContainer,
  DescriptionText,
  LineBreak,
  TextAndCalculationContainer,
  DescriptionContainer,
  AmountText,
  Row,
  OperatorContainer,
  CalculationBlock,
  Values,
} from './NetApyCalculationTooltip.styles';

interface NetApyCalculationTooltipProps {
  ousdApy: number;
  leverageMultiplier: number;
  leveragedApy: number;
  multiplierBasedOnPerformanceFee: number;
  finalOusdApy: number;
}

const NetApyCalculationTooltip = ({
  ousdApy,
  leverageMultiplier,
  leveragedApy,
  multiplierBasedOnPerformanceFee,
  finalOusdApy,
}: NetApyCalculationTooltipProps) => {
  return (
    <Tooltip position="right" name="NetApyCalc">
      <Container>
        <TitleContainer>
          <DescriptionText type="span" tooltipTitle>
            Estimated Net APY post performance fee.
          </DescriptionText>
        </TitleContainer>
        <DescriptionText type="span">Calculation: </DescriptionText>
        <LineBreak />
        <TextAndCalculationContainer>
          <DescriptionContainer>
            <DescriptionText type="span" lighterText>
              Base APY
            </DescriptionText>
            <DescriptionText type="span" lighterText>
              Leverage
            </DescriptionText>
            <LineBreak hide />
            <DescriptionText type="span" lighterText>
              Leveraged APY
            </DescriptionText>
          </DescriptionContainer>
          <CalculationBlock>
            <Row>
              <OperatorContainer position="left">
                <AmountText type="span">&nbsp;</AmountText>
              </OperatorContainer>
              <Values>
                <AmountText type="span">{Number(ousdApy)?.toFixed(2)}</AmountText>
              </Values>
              <OperatorContainer position="right">
                <AmountText type="span">%</AmountText>
              </OperatorContainer>
            </Row>
            <Row>
              <OperatorContainer position="left">
                <AmountText type="span">x</AmountText>
              </OperatorContainer>
              <Values>
                <AmountText type="span">{Number(leverageMultiplier)?.toFixed(2)}</AmountText>
              </Values>
              <OperatorContainer position="right">
                <AmountText type="span">&nbsp;</AmountText>
              </OperatorContainer>
            </Row>
            <LineBreak />
            <Row>
              <OperatorContainer position="left">
                <AmountText type="span">&nbsp;</AmountText>
              </OperatorContainer>
              <Values>
                <AmountText type="span">{Number(leveragedApy)?.toFixed(2)}</AmountText>
              </Values>
              <OperatorContainer position="right">
                <AmountText type="span">%</AmountText>
              </OperatorContainer>
            </Row>
          </CalculationBlock>
        </TextAndCalculationContainer>
        <LineBreak />
        <TextAndCalculationContainer>
          <DescriptionContainer>
            <DescriptionText type="span" lighterText>
              &nbsp;
            </DescriptionText>
            <DescriptionText type="span" lighterText>
              Performance Fee
            </DescriptionText>
            <DescriptionText type="span" lighterText>
              <small>
                <em>30% of Leveraged APY</em>
              </small>
            </DescriptionText>
            <LineBreak hide />
            <DescriptionText type="span" lighterText>
              Net APY
            </DescriptionText>
          </DescriptionContainer>
          <CalculationBlock>
            <Row>
              <OperatorContainer position="left">
                <AmountText type="span">&nbsp;</AmountText>
              </OperatorContainer>
              <Values>
                <AmountText type="span">{Number(leveragedApy)?.toFixed(2)}</AmountText>
              </Values>
              <OperatorContainer position="right">
                <AmountText type="span">%</AmountText>
              </OperatorContainer>
            </Row>
            <Row>&nbsp;</Row>
            <Row>
              <OperatorContainer position="left">
                <AmountText type="span">x</AmountText>
              </OperatorContainer>
              <Values>
                <AmountText type="span">{multiplierBasedOnPerformanceFee}</AmountText>
              </Values>
              <OperatorContainer position="right">
                <AmountText type="span">&nbsp;</AmountText>
              </OperatorContainer>
            </Row>
            <LineBreak />
            <Row>
              <OperatorContainer position="left">
                <AmountText type="span">&nbsp;</AmountText>
              </OperatorContainer>
              <Values>
                <AmountText type="span" bold>
                  {Number(finalOusdApy)?.toFixed(2)}
                </AmountText>
              </Values>
              <OperatorContainer position="right">
                <AmountText type="span" bold>
                  %
                </AmountText>
              </OperatorContainer>
            </Row>
          </CalculationBlock>
        </TextAndCalculationContainer>
      </Container>
    </Tooltip>
  );
};

export default NetApyCalculationTooltip;
